import React from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import GridItem from "../components/grid/GridItem.js";


export const LoadingText = () => {
  return (
    <GridItem xs={12} sm={10} md={10}>
      <Skeleton variant="text" style={{margin: "auto"}}/>
      <Skeleton variant="text" style={{margin: "auto"}}/>
    </GridItem>
    )
   }

 export const LoadingGraph = () => {
  return (
    <GridItem xs={12} sm={12} md={4} >
    <div style={{margin: "20px"}}>
    <Skeleton variant="rect" width={270} height={210} style={{margin: "auto"}}/>
      <Skeleton variant="text" width={270} style={{margin: "auto"}}/>
      <Skeleton variant="text" width={270} style={{margin: "auto"}}/>
      </div>
   </GridItem>
  )
 }